import React from 'react';
import Icon from '../../../components/AppIcon';

const AuditTrail = ({ activities }) => {
  const getActivityIcon = (type) => {
    const icons = {
      'Created': 'FilePlus',
      'Updated': 'Edit',
      'Approved': 'CheckCircle2',
      'Extended': 'Clock',
      'Commented': 'MessageSquare',
      'Closed': 'XCircle',
      'Attachment': 'Paperclip'
    };
    return icons?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colors = {
      'Created': 'text-primary',
      'Updated': 'text-accent',
      'Approved': 'text-success',
      'Extended': 'text-warning',
      'Commented': 'text-secondary',
      'Closed': 'text-muted-foreground',
      'Attachment': 'text-accent'
    };
    return colors?.[type] || 'text-muted-foreground';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-card">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="History" size={20} color="var(--color-primary)" />
        <h2 className="text-lg font-semibold text-foreground">Audit Trail</h2>
      </div>
      <div className="space-y-3 max-h-96 overflow-y-auto">
        {activities?.map((activity) => (
          <div key={activity?.id} className="flex gap-3 p-3 rounded-lg hover:bg-accent/5 transition-colors">
            <div className={`w-8 h-8 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0 ${getActivityColor(activity?.type)}`}>
              <Icon name={getActivityIcon(activity?.type)} size={16} />
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-2 mb-1">
                <p className="text-sm text-foreground">
                  <span className="font-medium">{activity?.user}</span>
                  <span className="text-muted-foreground"> {activity?.action}</span>
                </p>
                <span className="text-xs text-muted-foreground whitespace-nowrap">{activity?.timestamp}</span>
              </div>
              {activity?.details && (
                <p className="text-xs text-muted-foreground">{activity?.details}</p>
              )}
              {activity?.changes && (
                <div className="mt-2 p-2 bg-muted/50 rounded text-xs">
                  {activity?.changes?.map((change, index) => (
                    <div key={index} className="flex items-center gap-2 text-muted-foreground">
                      <Icon name="ArrowRight" size={12} />
                      <span>{change}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AuditTrail;